import {
  Component,
  ViewEncapsulation,
  Inject,
  forwardRef,
  Optional
} from '@angular/core';
import {MdlLayoutComponent} from './mdl-layout.component';


export class MdlLayoutDrawerComponent {

  public isDrawerVisible = false;

  constructor(  private parentLayout: MdlLayoutComponent) {

  }

  public isDrawerDirectChildOf(layout: MdlLayoutComponent) {
    return this.parentLayout === layout;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-layout-drawer',
  host: {
    '[class.mdl-layout__drawer]': 'true',
    '[class.is-visible]': 'isDrawerVisible'
  },
  template:
    `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlLayoutComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => MdlLayoutComponent), ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
